import { GET, POST, PUT, DELETE } from "../../../api";

export const declareResultAPI = async (data) => {

  return await POST(`/admin/matka/declare-result`, data,process.env.REACT_APP_MATKA_BASE_URL);
};


export const reverseResultAPI = async (result_id, type) => {

  return await POST(`/admin/matka/reverse-result`, { result_id, type },process.env.REACT_APP_MATKA_BASE_URL);
};

